import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb759bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { notify } from '@kyvg/vue3-notification'

import { IUser } from '@/api/AuthApi/types'
import UserApi from '@/api/UserApi'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import Select from '@/components/Select/Select.vue'
import { NOTIFICATION_TYPES } from '@/components/constants'
import { availableLocales, scopedTranslation, t } from '@/i18n'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const supportedLocales = computed(() =>
  availableLocales.map(locale => ({
    label: t(`user.selectedLocale.${locale}`),
    value: locale,
  })),
)

const { sT } = scopedTranslation('user')
const loading = ref(true)
const currentUser = ref<IUser | null>(null)
const selectedLocale = ref<string | undefined>('')

const handleSelect = async (value: string) => {
  selectedLocale.value = value
  const result = await UserApi.updateUserLanguage(selectedLocale.value)

  if (result) {
    store.commit('setLanguage', result.language)
    await fetchUserData()
  } else {
    notify({
      type: NOTIFICATION_TYPES.ERROR,
      text: sT('updateErrorMessage'),
    })
  }
}

const fetchUserData = async () => {
  const user = await UserApi.getUser()
  currentUser.value = user
  selectedLocale.value = user?.language
}

onMounted(async () => {
  await fetchUserData()
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(sT)('details')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(sT)('name')), 1),
            _createTextVNode(": " + _toDisplayString(currentUser.value?.first_name) + " " + _toDisplayString(currentUser.value?.last_name), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(sT)('email')), 1),
            _createTextVNode(": " + _toDisplayString(currentUser.value?.email), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(sT)('locale')), 1),
            _createTextVNode(": " + _toDisplayString(currentUser.value?.language &&
          _ctx.$t(`user.selectedLocale.${currentUser.value.language}`)), 1)
          ])
        ]),
        _createElementVNode("h2", null, _toDisplayString(_unref(sT)('changeLocale')), 1),
        _createVNode(Select, {
          modelValue: selectedLocale.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((selectedLocale).value = $event)),
            handleSelect
          ],
          options: _unref(supportedLocales)
        }, null, 8, ["modelValue", "options"])
      ]))
}
}

})